// extracted by mini-css-extract-plugin
export default {"error_box":"index_error_box_G8ACL","error":"index_error_J9oY8"};